import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "../../utils/request";

// Insert Payment
export const sendContactUs = createAsyncThunk(
  "contact/sendContactUs",
  async (item, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const res = await request.post("https://ssl.vipwellness-suite.de/api/emails", item, {
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });

      if (res.data.approval_url) {
        window.location.href = res.data.approval_url; // Redirect user to the approval URL
      }
      alert("تم إرسال الرسالة بنجاح!");
      
      return res.data; // Returning the response data to the thunk
    } catch (error) {
      console.error(error.response?.data || error.message);
      return rejectWithValue(error.response?.data || error.message); // Handle error correctly
    }
  }
);

const initialState = { records: [], loading: false, error: null };

const contactSlice = createSlice({
  name: "contact",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(sendContactUs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendContactUs.fulfilled, (state, action) => {
        state.loading = false;
        state.records.push(action.payload);
      })
      .addCase(sendContactUs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default contactSlice.reducer;